import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const products = [
  {
    id: 1,
    name: "ANADROL-50",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/ANADROL_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/Anadrol-50.jpg",
    description:
      "Oxymetholone promote weight gain and muscle growth in certain situations. Oxymetholone is a derivative of (DHT), featuring a chemical structure that resists aromatization. Despite not converting directly to estradiol, it exhibits strong estrogenic properties, contributing to its unique effects on the body.",
    strength: "50mg/Tablet",
    dosage: "50-100mg Per Day",
    packaging: "100 Tablets",
  },
  {
    id: 2,
    name: "ANAVAR-10",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/ANAVAR_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/Anavar-10.jpg",
    description:
      "Anavar (Oxandrolone) is an oral anabolic derived from dihydrotestosterone (DHT). It is known for its mild androgenic properties and strong anabolic effects, making it a popular choice for both cutting and lean bulking cycles. Anavar promotes muscle hardness, enhances strength, and supports fat loss while minimizing water retention, resulting in a lean, defined physique.",
    strength: "10mg/Tablet",
    dosage: "30-50mg Per Day",
    packaging: "100 Tablets",
  },
  {
    id: 3,
    name: "CLEN",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/CLEN_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/clen.jpg",
    description:
      "A highly effective fat-loss stimulant with anti-catabolic properties, helping to preserve lean muscle mass while promoting rapid fat reduction.",
    strength: "40mcg/Tablet",
    dosage: "40mcg - 80mcg Per Day",
    packaging: "100 Tablets",
  },
  {
    id: 4,
    name: "Dianabol",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/DIANABOL_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/Dianabol.jpg",
    description:
      "DANABOL Delivers rapid strength gains and significant weight increase, providing an intense muscle pump. Renowned as one of the most popular and widely used anabolic worldwide.",
    strength: "10mg/Tablet",
    dosage: "20mg - 50mg Per day",
    packaging: "100 tablets",
  },
  {
    id: 5,
    name: "STANA",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/STANA_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/STANA.jpg",
    description:
      "STANA Promotes a hard, dry, and chiseled appearance, enhancing muscle definition. It increases vascularity, strength, and muscle pump, making it an ideal choice for competition preparation.",
    strength: "10mg/Tablet",
    dosage: "30mg - 60mg Per Day",
    packaging: "100 Tablets",
  },
  {
    id: 6,
    name: "T3-50",
    category: "TABLETS",
    image: "/assets/images/Olympia_IMG/T-Tab.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/t3.jpg",
    description:
      "It promotes rapid fat loss and significantly stimulates thermogenesis, helping to accelerate metabolism. Additionally, it boosts energy levels, supporting enhanced performance and endurance.",
    strength: "50mcg/tab",
    dosage: "25mcg - 100mcg Per Day",
    packaging: "50 Tablets",
  },
  {
    id: 7,
    name: "BULK 600",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/BULK_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/bulk.jpg",
    description:
      "Bulk Blend promotes the development of lean muscle mass and enhances strength gains, making it an excellent choice for individuals aiming to build a more muscular and defined physique.",
    strength: "600mg/ml",
    dosage: "600mg - 1200mg/week",
    packaging: "10 ml Vial",
  },
  {
    id: 8,
    name: "CUT MIX-200",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-CUT.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/cut.jpg",
    description:
      "This blend features an optimal ratio of Trenbolone, Drostanolone, and Testosterone, providing a powerful combination of active agents. Designed to support muscle growth, strength, and fat loss, it helps users achieve their performance and physique goals efficiently.",
    strength: "200mg/ml",
    dosage: "400mg - 600mg/week",
    packaging: "10 ml vial",
  },
  {
    id: 9,
    name: "EQ-300",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-EQ.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/eq.jpg",
    description:
      "Boldenone significantly stimulates hematopoiesis, leading to an increase in red blood cell production. Higher red blood cell levels enhance oxygen delivery to the muscles, making this steroid particularly appealing to track and field athletes seeking improved endurance and performance.",
    strength: "300mg/ml",
    dosage: "300mg - 600mg/week",
    packaging: "10 ml vial",
  },
  {
    id: 10,
    name: "Primabolan 100",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-Primabolan.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/primobolan.jpg",
    description:
      "Methenolone is an anabolic derived from Dihydrotestosterone(DHT), featuring low androgenic activity and moderate anabolic effects. In addition to promoting muscle growth, Methenolone has been shown to have beneficial effects on the immune system, supporting overall health and recovery.",
    strength: "100mg/ml",
    dosage: "200mg - 600mg/week",
    packaging: "10 ml vial",
  },
  {
    id: 11,
    name: "DECA",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-DECA.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/deca.jpg",
    description:
      "It is a potent anabolic with a range of benefits for users. Athletes often use it during the off-season to focus on bulking, gaining muscle mass, and increasing strength.",
    strength: "300mg/ml",
    dosage: "300mg - 600mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 12,
    name: "Masteron-P 100",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/box/MASTERON-P_NEW.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/masteron.jpg",
    description:
      "Drostanolone Propionate is often used at the end of a cycle to aid in contest preparation. Its powerful fat-burning properties help bodybuilders eliminate stubborn fat that diet and exercise alone may not address, resulting in a leaner, more defined physique.",
    strength: "100mg/ml",
    dosage: "100mg per Day",
    packaging: "10 ml vial",
  },
  {
    id: 13,
    name: "Sustanon 400",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-Sustanon.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/sustanon.jpg",
    description:
      "Sustanon 400 is a synthetic form of the natural male hormone testosterone. It helps restore deficient testosterone levels in adult men, addressing issues caused by low testosterone such as impotence, infertility, low libido, fatigue, mood swings, and bone loss.",
    strength: "400mg/ml",
    dosage: "400mg - 800mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 14,
    name: "Test-C 250",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TestC.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/testC.jpg",
    description:
      "It is a synthetic form of testosterone that provides the body with benefits similar to those of naturally produced testosterone. This hormone plays a vital role in supporting both mental and physical well-being in men, influencing functions such as mood, energy levels, muscle growth, and overall health.",
    strength: "250mg/ml",
    dosage: "500mg - 750mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 15,
    name: "Test-E 250",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TestE.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/testE.jpg",
    description:
      "Test E is suitable for athletes at all experience levels beginners, intermediates, and advanced users. It's an ideal starting point for those new to anabolics, offering a balanced introduction to muscle growth, strength gains, and performance enhancement.",
    strength: "250mg/ml",
    dosage: "500mg - 750mg / week",
    packaging: "10ml vial",
  },
  {
    id: 16,
    name: "Test-P 100",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TestP.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/testP.jpg",
    description:
      "Testosterone Propionate is a fast-acting, purified form of the testosterone hormone. Its synthetic formulation is designed to mimic the body's natural testosterone, triggering identical physiological responses. This allows for effective support of muscle growth, energy levels, and overall male health.",
    strength: "100mg/ml",
    dosage: "300mg - 600mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 17,
    name: "TREN A-100",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TREN_A.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/trenA.jpg",
    description:
      "Even when stacked with other anabolics Trenbolone Acetate stands out for its unmatched potency. Its effects are so powerful that it delivers superior results on its own, surpassing the combined impact of multiple anabolics.",
    strength: "100mg/ml",
    dosage: "300mg - 400mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 18,
    name: "TREN H-76.5",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TREN_H.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/trenH.jpg",
    description:
      "Trenbolone Hexahydrobenzylcarbonate is a the powerful anabolic. It is known for its sustained release, requiring fewer injections while delivering consistent muscle-building and fat-burning effects. Widely used in cutting cycles, it helps preserve lean muscle mass and enhances physical definition.",
    strength: "76.5 mg/ml",
    dosage: "76.5mg - 114.75mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 19,
    name: "TREN MIX-325",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TREN_MIX.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/tren.jpg",
    description:
      "Trenbolone Enanthate: A long-acting ester of Trenbolone, known for its sustained release and reduced injection frequency. It supports muscle growth, strength, and fat loss. Trembolone Acetate: A fast-acting form of Trenbolone with a shorter half-life, requiring more frequent injections. It is popular for its rapid results in muscle hardening and fat reduction. Trenbolone Henanydrobenzyicarbonate: A medium-acting Trenbolone ester that provides a balance between injection frequency and sustained release. It promotes lean muscle retention and fat loss, often used during cutting cycles.",
    strength: "325mg/ml",
    dosage: "As Priscribed",
    packaging: "10 ml vial",
  },
  {
    id: 20,
    name: "TREN E-200",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-TrenE.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/trenE.jpg",
    description:
      "Trenbolone Enanthate is a potent anabolics known for its long-lasting effects, requiring fewer injections compared to similar products. Popular among athletes during cutting cycles, it supports the retention of lean muscle mass while promoting a more defined, sculpted physique.",
    strength: "200mg/ml",
    dosage: "400mg - 600mg / week",
    packaging: "10 ml vial",
  },
  {
    id: 21,
    name: "WINSTROL-100",
    category: "INJECTABLES",
    image: "/assets/images/Olympia_IMG/Inject-WINSTROL.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/winstrol.jpg",
    description:
      "Stanozolol helps preserve lean muscle tissue during a cutting cycle, preventing muscle loss while reducing body fat. It can also be used in a bulking cycle when combined with other anabolics to enhance muscle growth and strength.",
    strength: "100mg/ml",
    dosage: "100mg/Alt. Day",
    packaging: "10 ml vial",
  },
  {
    id: 22,
    name: "HGH Frag 176-191",
    category: "PEPTIDES",
    image: "/assets/images/Olympia_IMG/Peptides-FRAG.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/frag.jpg",
    description:
      "HGH Frag 176-191 is a modified fragment of the growth hormone (GH) polypeptide, specifically amino acids 176-191. It enhances the fat-burning process and boosts the appetite-suppressing effects of many over-the-counter fat burners.",
    strength: "2mg/vial",
    dosage: "200mcg - 400mcg / Day",
    packaging: "5 vials of 2mg of HGH Frag 176-191",
  },
  {
    id: 23,
    name: "GHRP-6",
    category: "PEPTIDES",
    image: "/assets/images/Olympia_IMG/Peptides-GRP6.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/grh.jpg",
    description:
      "GHRP-6 stimulates the natural production of human growth hormone (HGH) in the body, delivering effects similar to synthetic HGH. These benefits include accelerated fat loss, a significant increase in appetite, improved sleep quality, and faster recovery from workouts.",
    strength: "5mg/vial",
    dosage: "200mcg - 400mcg Twice A Day",
    packaging: "5 vials of 5mg of GHRP-6",
  },
  {
    id: 24,
    name: "Human Growth Hormone (HGH)",
    category: "PEPTIDES",
    image: "/assets/images/Olympia_IMG/Peptides-HGH.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/hgh.jpg",
    description:
      "Human Growth Hormone (HGH) is a popular choice among bodybuilders due to its ability to increase lean muscle mass, accelerate recovery between workouts, and boost overall performance with a lower risk of detection compared to other performance-enhancing drugs. It strengthens joints and ligaments, promotes tissue repair, and enhances protein synthesis. Additionally, HGH improves the body's ability to utilize insulin effectively and maximizes the effectiveness of anabolic steroids, supporting greater muscle growth and athletic performance.",
    strength: "12 I.U./vial",
    dosage: "4IU - 6IU / Day",
    packaging: "5 vials of 12 UI of Somatropin 191aa",
  },
  {
    id: 25,
    name: "IGF-1 LR3",
    category: "PEPTIDES",
    image: "/assets/images/Olympia_IMG/Peptides-IGF.png",
    secondaryImage: "/assets/images/Olympia_IMG/Banners/olpmpians Box/olpmpians Box/igf.jpg",
    description:
      "Stimulates localized muscle growth, supports nerve tissue regeneration, and promotes fat burning. It enhances protein transport into cells, reduces protein breakdown, and lowers LDL cholesterol levels, contributing to improved overall health and performance.",
    strength: "100mcg/vial",
    dosage: "40mcg - 100mcg / Day",
    packaging: "5 vials of 100 mcg of IGF-1 LR3",
  },
];

export default function ProductsSingle() {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));

  // 👇 Scroll to top when component loads or when product changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!product) {
    return (
      <div className="container mt-5">
        <h2>Product Not Found</h2>
        <Link to="/shop" className="btn btn-primary">
          Back to Shop
        </Link>
      </div>
    );
  }

  return (
    <>
  

      <div className="page-content">
        {/* <!--product start--> */}
     
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                <div
                  id="productCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        className="d-block img-fluid rounded w-100"
                        src={product.image}
                        alt={`${product.name} primary`}
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="modal"
                        data-bs-target="#imageModal"
                        onClick={(e) => {
                          document.getElementById("modalImage").src =
                            e.target.src;
                        }}
                        onError={(e) => {
                          e.target.src = "/assets/images/placeholder.png";
                          console.error(`Failed to load image: ${product.image}`);
                        }}
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        className="d-block img-fluid rounded w-100"
                        src={
                          product.secondaryImage || "/assets/images/placeholder.png"
                        }
                        alt={`${product.name} secondary`}
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="modal"
                        data-bs-target="#imageModal"
                        onClick={(e) => {
                          document.getElementById("modalImage").src =
                            e.target.src;
                        }}
                        onError={(e) => {
                          e.target.src = "/assets/images/placeholder.png";
                          console.error(
                            `Failed to load secondary image: ${product.secondaryImage}`
                          );
                        }}
                      />
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#productCarousel"
                    data-bs-slide="prev"
                    style={{
                      filter: "invert(100%)", // Makes the arrow black
                    }}
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#productCarousel"
                    data-bs-slide="next"
                    style={{
                      filter: "invert(100%)", // Makes the arrow black
                    }}
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#productCarousel"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#productCarousel"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                  </div>
                </div>
                {/* Modal for full-size image */}
                <div
                  className="modal fade"
                  id="imageModal"
                  tabIndex="-1"
                  aria-labelledby="imageModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="imageModalLabel">
                          {product.name}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body text-center">
                        <img
                          id="modalImage"
                          className="img-fluid"
                          src=""
                          alt={`${product.name} full-size`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-6 mt-5 mt-md-0 ps-lg-5">
                <div className="product-details">
                  <h3>{product.name}</h3>
                  <ul className="list-unstyled mb-4">
                    <li>
                      <span className="text-black">Categories:</span>{" "}
                      {product.category}
                    </li>
                  </ul>
                  <p>{product.description}</p>
                  <div className="row my-4">
                    {/* Strength Box */}
                    <div className="col-lg-4 col-md-6 mb-4">
                      <div
                        className="p-4 rounded-3 text-white text-center shadow-lg h-100"
                        style={{
                          background: "linear-gradient(135deg, #0d3b66, #1d4e89)",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 22px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 16px rgba(0,0,0,0.15)";
                        }}
                      >
                        <h6 className="fw-bold text-white mb-2">Strength</h6>
                        <p className="mb-0">{product.strength}</p>
                      </div>
                    </div>
                    {/* Dosage Box */}
                    <div className="col-lg-4 col-md-6 mb-4">
                      <div
                        className="p-4 rounded-3 text-white text-center shadow-lg h-100"
                        style={{
                          background: "linear-gradient(135deg, #3f88c5, #5fa8d3)",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 22px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 16px rgba(0,0,0,0.15)";
                        }}
                      >
                        <h6 className="fw-bold text-white mb-2">Dosage</h6>
                        <p className="mb-0">{product.dosage}</p>
                      </div>
                    </div>
                    {/* Packaging Box */}
                    <div className="col-lg-4 col-md-6 mb-4">
                      <div
                        className="p-4 rounded-3 text-white text-center shadow-lg h-100"
                        style={{
                          background: "linear-gradient(135deg, #2d6a4f, #40916c)",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 22px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 16px rgba(0,0,0,0.15)";
                        }}
                      >
                        <h6 className="fw-bold text-white mb-2">Packaging</h6>
                        <p className="mb-0">{product.packaging}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      
        {/* <!--product end--> */}

        {/* <!--tab start--> */}
        <section className="pt-3">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="tab">
                  {/* <!-- Nav tabs --> */}
                  <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        className="nav-item nav-link active ms-0"
                        id="nav-tab1"
                        data-bs-toggle="tab"
                        href="#tab3-1"
                        role="tab"
                        aria-selected="true"
                      >
                        Description
                      </a>
                      <a
                        className="nav-item nav-link"
                        id="nav-tab2"
                        data-bs-toggle="tab"
                        href="#tab3-2"
                        role="tab"
                        aria-selected="false"
                      >
                        Additional Information
                      </a>
                    </div>
                  </nav>
                  {/* <!-- Tab panes --> */}
                  <div className="tab-content p-0 pt-5">
                    <div
                      role="tabpanel"
                      className="tab-pane fade show active"
                      id="tab3-1"
                    >
                      <h5 className="mb-3">Product Description</h5>
                      <p className="mb-0">{product.description}</p>
                    </div>
                    <div role="tabpanel" className="tab-pane fade" id="tab3-2">
                      <h5 className="mb-3">Additional Information</h5>
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td>Strength</td>
                            <td>{product.strength}</td>
                          </tr>
                          <tr>
                            <td>Dosage</td>
                            <td>{product.dosage}</td>
                          </tr>
                          <tr>
                            <td>Packaging</td>
                            <td>{product.packaging}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--tab end--> */}
      </div>
    </>
  );
}